import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFinanzasV2DashboardMensual, getFinanzasV2DashboardAnual } from "../../helpers/finanzasV2Api";
import { resolveErpIds } from "../filters/reducer";

export const getFinanzasV2MensualData = createAsyncThunk(
  "dashboardFinanzasV2/getMensual",
  async ({ month } = {}, { getState }) => {
    const state = getState();
    const empresaId = resolveErpIds(state);
    const year = state.Filters.year;
    return await getFinanzasV2DashboardMensual(empresaId, year, month);
  }
);

export const getFinanzasV2AnualData = createAsyncThunk(
  "dashboardFinanzasV2/getAnual",
  async (_, { getState }) => {
    const state = getState();
    const empresaId = resolveErpIds(state);
    const year = state.Filters.year;
    return await getFinanzasV2DashboardAnual(empresaId, year);
  }
);
